var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.498,
    height: 13.236,
    viewBox: "0 0 17.498 13.236",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye-svgrepo-com_2_",
    "data-name": "eye-svgrepo-com (2)",
    transform: "translate(-1.709 -4.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9035",
    "data-name": "Trazado 9035",
    d: "M14.03,11.515A2.515,2.515,0,1,1,11.515,9,2.515,2.515,0,0,1,14.03,11.515Z",
    transform: "translate(-1.058 -0.647)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9036",
    "data-name": "Trazado 9036",
    d: "M10.458,5a8.386,8.386,0,0,0-8,5.868,8.386,8.386,0,0,0,16,0A8.386,8.386,0,0,0,10.458,5Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.ae118c6df372c01bb85c2697591820b8.svg";
export { ForwardRef as ReactComponent };